<template>
  <div class="card">
    <h3 v-if="title">{{title}}</h3>
    <img v-if="image" :src="image">
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },

    image: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.25);
  display: block;

  &:hover {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.28);
    h3 {
      color: blue;
    }
  }

  h3 {
    // margin: 10px;
    padding: 10px 10px 0;
    line-height: 1.3;
  }

  img {
    max-width: 100%;
    margin: 10px 0;
  }

  time {
    margin: 0 10px;
    padding-bottom: 10px;
    display: block;
  }
}
</style>
